import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from "@simonbackx/simple-encoding";
import { OrganizationPaymentMandate } from "./OrganizationPaymentMandate";
import { STCredit } from "./STCredit";
import { STInvoice, STPendingInvoice } from "./STInvoice";
import { STPackage } from "./STPackage";
export class STBillingStatus extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.mandates = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(STInvoice) })
], STBillingStatus.prototype, "invoices", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(STPackage) })
], STBillingStatus.prototype, "packages", void 0);
__decorate([
    field({ decoder: STPendingInvoice, nullable: true })
], STBillingStatus.prototype, "pendingInvoice", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(STCredit) })
], STBillingStatus.prototype, "credits", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(OrganizationPaymentMandate), optional: true })
], STBillingStatus.prototype, "mandates", void 0);
//# sourceMappingURL=STBillingStatus.js.map